import './PerspectiveInfoSheet.css';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { PERSPECTIVES } from './perspectives.js';
import { PERSP_COLOR } from './PerspChart.jsx';

export default function PerspectiveInfoSheet({ open, onClose, cohorts }) {
  const { t, i18n } = useTranslation();
  const history = useHistory();
  const lang    = i18n.language?.slice(0, 2) || 'en';
  const langKey = ['de', 'fr'].includes(lang) ? lang : 'en';

  const goToUserBase = () => {
    onClose();
    history.push('/users');
  };

  useEffect(() => {
    if (!open) return;
    const onKey = (e) => { if (e.key === 'Escape') onClose(); };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [open, onClose]);

  // Build display rows from dynamic cohorts when provided, else fall back to global PERSPECTIVES
  const rows = cohorts
    ? cohorts.map(c => ({
        id:     c.id,
        color:  c.color,
        name:   c.label[langKey] || c.label.en,
        blurb:  c.blurb[langKey] || c.blurb.en,
        verify: c.source[langKey] || c.source.en,
      }))
    : PERSPECTIVES.map(p => ({
        id:     p.id,
        color:  PERSP_COLOR[p.id],
        name:   lang === 'de' ? p.name_de : lang === 'fr' ? p.name_fr : p.name_en,
        blurb:  t(`persp.${p.id}.blurb`),
        verify: t(`persp.${p.id}.verify`),
      }));

  return (
    <div
      className={`pis-backdrop${open ? ' pis-backdrop--open' : ''}`}
      onClick={onClose}
      aria-hidden={!open}
    >
      <div
        className="pis-card"
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-label={t('persp.sheet.title')}
      >
        <div className="pis-header">
          <h2 className="pis-title">{t('persp.sheet.title')}</h2>
          <button className="pis-close" onClick={onClose} aria-label="Close">×</button>
        </div>

        <ul className="pis-list">
          {rows.map((p) => (
            <li key={p.id} className="pis-row">
              <span className="pis-dot" style={{ background: p.color }} />
              <div className="pis-content">
                <span className="pis-name">{p.name}</span>
                <span className="pis-blurb">{p.blurb}</span>
                <span className="pis-verify">{p.verify}</span>
              </div>
            </li>
          ))}
        </ul>

        <button className="pis-userbase" onClick={goToUserBase}>
          <svg className="pis-userbase-icon" width="16" height="16" viewBox="0 0 16 16" fill="none"
            stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="5.5" cy="5" r="2.2" />
            <circle cx="11" cy="6" r="1.7" />
            <path d="M1.5 13c0-2 1.8-3.4 4-3.4s4 1.4 4 3.4" />
            <path d="M10 9.7c1.9 0 3.4 1.2 3.4 3" />
          </svg>
          <span className="pis-userbase-label">{t('persp.sheet.userBase')}</span>
          <svg className="pis-userbase-chevron" width="14" height="14" viewBox="0 0 16 16" fill="none"
            stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M6 3l5 5-5 5" />
          </svg>
        </button>
      </div>
    </div>
  );
}
